module.exports = __webpack_public_path__ + "static/1.3_the_tools_of_history-a710c52079c7a23491c592b41c4e595e.pdf";